import { useNavGroups } from '@/components/layout/nav-config';
import { NavMain } from '@/components/layout/NavMain';
import { UserProfileCard } from '@/components/layout/UserProfileCard';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/shadcn/avatar';
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from '@/components/ui/shadcn/sidebar';
import { useInitials } from '@/hooks/use-initials';
import { useIsMobile } from '@/hooks/use-mobile';
import { type NavGroup, type SharedData, type User } from '@/types';
import { Link, usePage } from '@inertiajs/react';
import AppLogo from '../layout/AppLogo';

export function AppSidebar() {
    const isMobile = useIsMobile();
    const { sections, hiddenGroup } = useNavGroups();
    const groups: NavGroup[] = hiddenGroup ? [...sections, hiddenGroup] : sections;
    const { auth } = usePage<SharedData>().props;
    const user = auth.user as User;
    const getInitials = useInitials();

    return (
        <>
            {/* Desktop Sidebar */}
            {!isMobile && (
                <Sidebar collapsible="icon" variant="inset">
                    <SidebarHeader>
                        <SidebarMenu>
                            <SidebarMenuItem>
                                <SidebarMenuButton asChild className="h-12 justify-center hover:bg-transparent active:bg-transparent">
                                    <Link href="/" prefetch className="flex items-center justify-start">
                                        <AppLogo />
                                    </Link>
                                </SidebarMenuButton>
                            </SidebarMenuItem>
                        </SidebarMenu>
                    </SidebarHeader>

                    <SidebarContent>
                        <NavMain groups={groups} />
                    </SidebarContent>

                    <SidebarFooter>
                        <SidebarMenu>
                            <SidebarMenuItem>
                                <UserProfileCard user={user}>
                                    <SidebarMenuButton size="lg" tooltip={`${user.first_name} ${user.last_name}`}>
                                        <Avatar className="size-8 shrink-0 overflow-hidden rounded-full">
                                            <AvatarImage src={user.avatar} alt={user.first_name} />
                                            <AvatarFallback className="bg-muted text-muted-foreground rounded-full text-xs">
                                                {getInitials(`${user.first_name} ${user.last_name}`)}
                                            </AvatarFallback>
                                        </Avatar>
                                        <div className="grid min-w-0 flex-1 text-left text-sm leading-tight">
                                            <span className="truncate font-medium">
                                                {user.first_name} {user.last_name}
                                            </span>
                                            {user.role && <span className="text-muted-foreground truncate text-xs">{user.role}</span>}
                                        </div>
                                    </SidebarMenuButton>
                                </UserProfileCard>
                            </SidebarMenuItem>
                        </SidebarMenu>
                    </SidebarFooter>
                </Sidebar>
            )}
        </>
    );
}
